import { keyframes, styled } from '../../../lib/stitches'

const appear = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-10px)' },
  '100%': { opacity: 1, transform: 'translateY(0px)' }
})

const Badge = styled('div', {
  background: '$gray01',
  color: '$text__primary',
  fontFamily: '$azeret',
  fontSize: '10px',
  lineHeight: '10px',
  padding: '4px 8px',
  borderRadius: '$8',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${appear} 500ms ease-out`
})

export default Badge
